import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PhotoSelectorContext } from '../PhotoSelectorContext';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  totalPhotos: PropTypes.number,
  className: PropTypes.string,
};

const PhotoSelectorHeader = ({ totalPhotos, className }) => {
  const {
    selectedPhotos,
    selectionSettings,
    selectionEnabled,
    onResetSelection,
    onToggleSelectionEnabled,
  } = useContext(PhotoSelectorContext);
  const { isSelectAll } = selectionSettings;

  useEffect(() => {
    if (selectedPhotos.length === 0 && !isSelectAll) {
      onResetSelection();
    }
  }, [selectedPhotos.length]);

  const totalSelectedPhotos = selectedPhotos.length ?? 0;
  const classes = classNames({
    'hierarchy-item-photo-selector-header': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {totalPhotos > 0 && totalSelectedPhotos === 0 && !selectionEnabled && (
        <Button
          btnStyle="link"
          className="d-md-inline-flex ml-md-2 ml-auto"
          btnSize="sm"
          onClick={() => onToggleSelectionEnabled()}
        >
          Select Photos
        </Button>
      )}
    </div>
  );
};

PhotoSelectorHeader.propTypes = propTypes;

export default PhotoSelectorHeader;
